import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import ToolCard from './ToolCard.vue'
import { createCtx, handleError } from '../../../../helpers'
import { GeneratorTool } from './model'


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneratorToolCard',
  props: {
    title: {},
    generatorTool: {}
  },
  setup(__props: any) {

const props = __props;



const operationNumber = ref(10)
const createPercent = ref(40)
const modifyPercent = ref(50)
const deletePercent = ref(10)
const progress = ref(0)
const executing = ref(false)
const remainingMs = ref(0)

async function execute() {
  handleError(async () => {
    const ctx = createCtx()
    progress.value = 0
    const startTime = new Date().getTime()
    for (let i = 0; i < operationNumber.value; i++) {
      const t = createPercent.value + modifyPercent.value + deletePercent.value
      const k = Math.random() * t

      if (k >= 0 && k < createPercent.value) {
        await props.generatorTool.create(ctx)
      } else if (k >= createPercent.value && k < createPercent.value + modifyPercent.value) {
        await props.generatorTool.update(ctx)
      } else {
        await props.generatorTool.delete(ctx)
      }
      const currentTime = new Date().getTime()
      remainingMs.value = ((currentTime - startTime) / i) * (operationNumber.value - i)
      progress.value = i + 1
    }
  }, executing)
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(ToolCard, {
    title: _ctx.title,
    executing: executing.value,
    onExecute: execute,
    progress: progress.value,
    total: operationNumber.value,
    "remaining-ms": remainingMs.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                label: "Количество операций",
                type: "number",
                modelValue: operationNumber.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((operationNumber).value = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                label: "Процент созданий",
                type: "number",
                modelValue: createPercent.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createPercent).value = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                label: "Процент модификаций",
                type: "number",
                modelValue: modifyPercent.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modifyPercent).value = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                label: "Процент удалений",
                type: "number",
                modelValue: deletePercent.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deletePercent).value = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "executing", "progress", "total", "remaining-ms"]))
}
}

})